import React from "react";
import "./style.less";
import location from "../../images/careers/location.svg";
import portfolio from "../../images/careers/portfolio.svg";
import resume from "../../images/careers/resume.svg";
import search from "../../images/careers/search.svg";
import Button from "../Button/Button";

const JobPostItem = (props) => {
  return (
    <div className="postItemContainer">
      <div className="designation">{props.designation}</div>
      <div className="d-f locationContainer">
        <div className="d-f">
          <img src={location} />
          <div className="locationtxt">{props.location}</div>
        </div>
        <div className="d-f expContainer">
          <img src={portfolio} />
          <div className="locationtxt">
            {props.experienceInYear === "Fresher"
              ? "Fresher"
              : props.experience}
          </div>
        </div>
      </div>
      <div className="desc">{props.desc}</div>
      <div className="skillsTxt">
        Skills : <span>{props.skills}</span>
      </div>
      <div className="btnContainer">
        <Button onClick={props.onClick} title="Apply" />
      </div>
    </div>
  );
};

export default JobPostItem;
